import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '../units/Box/Box';
import Text from '../units/Text/Text';

const ErrorText = styled(Text).attrs({
  color: '#ee1c1c',
  font: 'caption',
  size: '12px',
  height: '16px'
})``;

const withValidation = (WrappedComponent, componentType) => {
  return class ComponentWithValidaiton extends React.Component {
    static propTypes = {
      validate: PropTypes.array,
      error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      active: PropTypes.bool,
      touched: PropTypes.bool,
      fieldType: PropTypes.string,
      maxLength: PropTypes.number,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
      ]),
      width: PropTypes.string,
      waitsServerResponse: PropTypes.bool
    };

    static defaultProps = {
      validate: null,
      active: false,
      touched: false,
      error: '',
      fieldType: null,
      maxLength: null,
      value: '',
      width: '100%',
      waitsServerResponse: false
    };

    hasTextError = () => {
      const { error, waitsServerResponse, active, touched } = this.props;

      return Boolean(error) && touched && !active && !waitsServerResponse;
    };

    renderTextError = () => {
      const { error, width } = this.props;

      const wrapperProps = {
        width,
        mt: '5px'
      };

      if (componentType === 'checkbox') {
        wrapperProps.m = '5px 0 0 20px';
      }

      return (
        <Box {...wrapperProps}>
          <ErrorText className="errorText">{error}</ErrorText>
        </Box>
      );
    };

    render() {
      const hasError = this.hasTextError();

      return (
        <Box>
          <WrappedComponent hasError={hasError} {...this.props} />
          {hasError && this.renderTextError()}
        </Box>
      );
    }
  };
};

export default withValidation;



// WEBPACK FOOTER //
// ./src/components/hocs/withValidation.js